import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { KeyValue } from '../models/common';
import { IQuoteSupplierItemStatus } from './base';
import { StatusCartFilterRequest } from '../models/request';

const baseRoute: string = 'QuoteSupplierItemStatus';

export class QuoteSupplierItemStatusApi extends IQuoteSupplierItemStatus {
  getDomain(request: StatusCartFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }
}

